import { ApiProperty } from "@nestjs/swagger";
import { IsAlphanumeric, IsNotEmpty, IsNumber, IsOptional } from "class-validator";

export class CodeListMainIdRequest {
    @ApiProperty()
    @IsNotEmpty()
    @IsAlphanumeric()
    saleOrderId: number;

    @ApiProperty()
    @IsOptional()
    updatedUser?: string;

    @ApiProperty()
    @IsOptional()
    @IsNumber()
    versionFlag?: number;

    @ApiProperty()
    isActive?: boolean;
    
    @ApiProperty()
    poNumber?:string

    @ApiProperty()
    unitId?:string
}